import { render, staticRenderFns } from "./shopBack.vue?vue&type=template&id=72266168&scoped=true"
import script from "./shopBack.vue?vue&type=script&lang=js"
export * from "./shopBack.vue?vue&type=script&lang=js"
import style0 from "./shopBack.vue?vue&type=style&index=0&id=72266168&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72266168",
  null
  
)

export default component.exports